import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  style: {
    "height": "8rem"
  }
};
const _hoisted_2 = {
  style: {
    "position": "fixed",
    "top": "0",
    "left": "0",
    "right": "0",
    "z-index": "9"
  }
};
const _hoisted_3 = {
  class: "nav_m"
};
const _hoisted_4 = {
  class: "btn-box"
};
const _hoisted_5 = {
  key: 0,
  class: "nav_list"
};
const _hoisted_6 = {
  key: 1,
  class: "nav_zon_list"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "item-box"
};
const _hoisted_9 = {
  key: 2,
  class: "logon-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_image, {
    onClick: _cache[0] || (_cache[0] = $event => $setup.nav_to('home')),
    class: "logo",
    src: "https://www.mimodental.com/assets/imgData/img/header/logo.png"
  }), _createElementVNode("div", {
    class: "more",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.showNavListAction && $setup.showNavListAction(...args))
  }, [!$setup.showNavList ? (_openBlock(), _createBlock(_component_van_image, {
    key: 0,
    class: "item-img",
    src: "https://www.mimodental.com/assets/imgData/img/header/mobile/more.png"
  })) : _createCommentVNode("", true), $setup.showNavList ? (_openBlock(), _createBlock(_component_van_image, {
    key: 1,
    class: "item-img",
    src: "https://www.mimodental.com/assets/imgData/img/header/mobile/close.png"
  })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "member",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.showLoginAction && $setup.showLoginAction(...args))
  }, [!$setup.showLogin ? (_openBlock(), _createBlock(_component_van_image, {
    key: 0,
    class: "item-img",
    src: "https://www.mimodental.com/assets/imgData/img/header/mobile/member.png"
  })) : _createCommentVNode("", true), $setup.showLogin ? (_openBlock(), _createBlock(_component_van_image, {
    key: 1,
    class: "item-img",
    src: "https://www.mimodental.com/assets/imgData/img/header/mobile/close.png"
  })) : _createCommentVNode("", true)])])]), $setup.showLogin ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[3] || (_cache[3] = $event => $setup.showLogin = !$setup.showLogin),
    class: "mask"
  })) : _createCommentVNode("", true), $setup.showNavList ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    onClick: _cache[4] || (_cache[4] = $event => $setup.showNavList = !$setup.showNavList),
    class: "mask"
  })) : _createCommentVNode("", true), $setup.showZonNavList ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    onClick: _cache[5] || (_cache[5] = $event => $setup.showZonNavList = !$setup.showZonNavList),
    class: "mask"
  })) : _createCommentVNode("", true)])]), $setup.showNavList ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
    class: "item",
    onClick: _cache[6] || (_cache[6] = $event => $setup.nav_to('home'))
  }, "首页"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[7] || (_cache[7] = $event => $setup.nav_to('about'))
  }, "关于米檬"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[8] || (_cache[8] = (...args) => $setup.showZonNavListAction && $setup.showZonNavListAction(...args))
  }, _cache[26] || (_cache[26] = [_createTextVNode("诊疗专区", -1), _createElementVNode("img", {
    class: "right-arrow",
    src: "https://www.mimodental.com/assets/imgData/img/header/mobile/right_arrow.png"
  }, null, -1)])), _createElementVNode("div", {
    class: "item",
    onClick: _cache[9] || (_cache[9] = $event => $setup.nav_to('science'))
  }, "口腔科普"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[10] || (_cache[10] = $event => $setup.nav_to('news'))
  }, "新闻资讯"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[11] || (_cache[11] = $event => $setup.nav_to('welfare'))
  }, "公益行动")])) : _createCommentVNode("", true), $setup.showZonNavList ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    onClick: _cache[12] || (_cache[12] = (...args) => $setup.showZonNavListAction && $setup.showZonNavListAction(...args)),
    class: "left-arrow",
    src: "https://www.mimodental.com/assets/imgData/img/header/mobile/left_arrow.png"
  }), _cache[27] || (_cache[27] = _createTextVNode(" 诊疗专区 ", -1))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    class: "item",
    onClick: _cache[13] || (_cache[13] = $event => $setup.nav_toParam('Zone_m', 72))
  }, "口腔正畸"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[14] || (_cache[14] = $event => $setup.nav_toParam('Zone_m', 73))
  }, "口腔种植"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[15] || (_cache[15] = $event => $setup.nav_toParam('Zone_m', 74))
  }, "牙周诊疗"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[16] || (_cache[16] = $event => $setup.nav_toParam('Zone_m', 75))
  }, "牙体牙髓"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[17] || (_cache[17] = $event => $setup.nav_toParam('Zone_m', 76))
  }, "儿童齿科"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[18] || (_cache[18] = $event => $setup.nav_toParam('Zone_m', 77))
  }, "牙齿美容"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[19] || (_cache[19] = $event => $setup.nav_toParam('Zone_m', 78))
  }, "微创拔牙"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[20] || (_cache[20] = $event => $setup.nav_toParam('Zone_m', 79))
  }, "牙齿修复"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[21] || (_cache[21] = $event => $setup.nav_toParam('Zone_m', 80))
  }, "PMTC口腔护理")])])) : _createCommentVNode("", true), $setup.showLogin ? (_openBlock(), _createElementBlock("div", _hoisted_9, [!$setup.userData ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[22] || (_cache[22] = $event => $setup.nav_toParam('login_m', 2)),
    class: "login"
  }, " 登录 ")) : _createCommentVNode("", true), !$setup.userData ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    onClick: _cache[23] || (_cache[23] = $event => $setup.nav_toParam('login_m', 0)),
    class: "register"
  }, " 注册 ")) : _createCommentVNode("", true), $setup.userData ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    onClick: _cache[24] || (_cache[24] = (...args) => $setup.go && $setup.go(...args)),
    class: "quit",
    style: {
      "background": "#41B9B2"
    }
  }, " 返回会员首页 ")) : _createCommentVNode("", true), $setup.userData ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    onClick: _cache[25] || (_cache[25] = (...args) => $setup.quitLogin && $setup.quitLogin(...args)),
    class: "quit",
    style: {
      "background": "#EFEFEF",
      "margin-bottom": "0"
    }
  }, " 退出登录 ")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64);
}